import React from "react";
import { PlatformLogo, PROVIDER_META, MediaProviderId } from "./MediaPlatformIcons";

// Carte affichée pour une story "Media Vibe" — au lieu d'une simple <img>, un fond dégradé
// propre à la plateforme (jamais sa couleur officielle) + logo + titre, avec la vignette oEmbed
// en surimpression légère quand elle existe (YouTube/Spotify/Deezer). Réutilisée à 3 endroits :
// preview de création, viewer de story, viewer de vibes d'un lieu.
export default function MediaStoryCard({
  provider, title, thumbnailUrl, url, renderCta = true,
}: {
  provider: MediaProviderId; title: string; thumbnailUrl?: string | null; url?: string | null; renderCta?: boolean;
}) {
  const meta = PROVIDER_META[provider];
  const [from, to] = meta.grad;

  return (
    <div style={{ width: "100%", height: "100%", position: "relative", background: `linear-gradient(160deg, ${from}, ${to})`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 28, boxSizing: "border-box", overflow: "hidden" }}>
      {thumbnailUrl && (
        <img src={thumbnailUrl} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.28 }} />
      )}
      <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: 18, maxWidth: 320 }}>
        <PlatformLogo id={provider} size={34} color="white" />
        {thumbnailUrl && (
          <img src={thumbnailUrl} alt="" style={{ width: "62%", aspectRatio: "16/9", objectFit: "cover", borderRadius: 16, boxShadow: "0 12px 30px rgba(0,0,0,0.45)" }} />
        )}
        <div style={{ color: "white", fontSize: 22, fontWeight: 800, textAlign: "center", lineHeight: 1.3, display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
          {title}
        </div>
        {renderCta && url && (
          <a
            href={url} target="_blank" rel="noopener noreferrer"
            style={{ display: "inline-block", padding: "10px 18px", borderRadius: 22, border: "1px solid rgba(255,255,255,0.4)", backgroundColor: "rgba(255,255,255,0.16)", color: "white", fontSize: 13.5, fontWeight: 700, textDecoration: "none" }}
          >
            {meta.verb} sur {meta.label}
          </a>
        )}
      </div>
    </div>
  );
}
